export default async function deleteTemplate({ commit, rootGetters, dispatch }, templateId) {
    try {
        commit('SET_DELETE_TEMPLATE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const url = `/proxy/ai/extract-templates?customer_id=${customer_id}&templateId=${templateId}`;
        const response = await window.axios.delete(url);

        if (response.data.success) {
            dispatch('notifications/pushNotification', 'Extract template deleted successfully', { root: true });

            const currentTemplates = rootGetters["extractTemplates/TEMPLATES"];
            const updatedTemplates = currentTemplates.filter(template => template.id !== templateId);
            commit('SET_TEMPLATES', updatedTemplates);
        } else {
            dispatch('notifications/setError', 'Failed to delete extract template', { root: true });
        }
    } catch (error) {
        console.error('Error deleting extract template:', error);
        dispatch('notifications/setError', 'Failed to delete extract template', { root: true });
    } finally {
        commit('SET_DELETE_TEMPLATE_LOADING', false);
    }
}